import { css } from '@lyearn/style';

export const progressIconStyles = css`
  > svg {
    width: 2.4rem;
    height: 2.4rem;
  }
`;
